var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var getIcon = function (hover) {
    var icon = "url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!-- Generator: Adobe Illustrator 19.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 128 128' style='enable-background:new 0 0 128 128;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23XXXXXX;%7D%0A%3C/style%3E%3Ctitle%3Ebold/x-bold%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cpath class='st0' d='M74.6,63.3L117,20.9c0.8-0.8,0.8-2,0-2.8l-8.5-8.5c-0.8-0.8-2-0.8-2.8,0L63.3,52L21.6,10.3 c-0.8-0.8-2-0.8-2.8,0l-8.5,8.5c-0.8,0.8-0.8,2,0,2.8L52,63.3L9.6,105.7c-0.8,0.8-0.8,2,0,2.8L18,117c0.8,0.8,2,0.8,2.8,0l42.4-42.4 l43.1,43.1c0.8,0.8,2,0.8,2.8,0l8.5-8.5c0.8-0.8,0.8-2,0-2.8L74.6,63.3z'/%3E%3C/svg%3E%0A\")";
    return icon.replace('XXXXXX', (hover ? '#275D90' : '#002E85').replace('#', ''));
};
/** @ignore */
export var colorIndexes = [
    { backgroundColor: '#626F79' },
    { backgroundColor: '#1CACB8' },
    { backgroundColor: '#403B9B' },
    { backgroundColor: '#2CA077' },
    { backgroundColor: '#EB680A' },
    { backgroundColor: '#BA0870' },
    { backgroundColor: '#C69F10' },
    { backgroundColor: '#E32131' },
    { backgroundColor: '#0A6E76' },
    { backgroundColor: '#7670DB' },
    { backgroundColor: '#F745AD' },
    { backgroundColor: '#428DD7' },
    { backgroundColor: '#207456' },
];
export var tag = {
    alignItems: 'center',
    background: '#323E48',
    border: '1px solid #E1E9F0',
    borderRadius: 8,
    boxSizing: 'border-box',
    color: '#ffffff',
    display: 'inline-flex',
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '20px',
    height: 24,
    padding: '2px 8px',
    verticalAlign: 'middle',
};
export var iconContainer = {
    marginTop: 2,
    paddingRight: 4,
    '[class*="icon-"].size-xsmall': {
        fontSize: 11,
    },
};
export var combinators = {
    '& + &': {
        marginLeft: 4,
    },
    '&:first-child': {
        marginLeft: 0,
    },
};
export var positive = __assign(__assign({}, tag), { background: '#E5FFE5', border: "1px solid ".concat('#007500'), color: '#000000' });
export var negative = __assign(__assign({}, tag), { background: '#FFEBED', border: "1px solid ".concat('#CC0821'), color: '#000000' });
export var warning = __assign(__assign({}, tag), { background: '#FFF6DE', border: "1px solid ".concat('#E5A700'), color: '#000000' });
export var pending = __assign(__assign({}, tag), { background: '#F5E5FF', border: "1px solid ".concat('#5E00A6'), color: '#000000' });
export var info = __assign(__assign({}, tag), { background: '#E5EFFF', border: "1px solid ".concat('#003FB8'), color: '#000000' });
export var white = __assign(__assign({}, tag), { background: '#ffffff', color: '#000000' });
export var gray = __assign(__assign({}, tag), { background: '#E1E9F0', border: "1px solid ".concat('#2A3742'), color: '#000000' });
export var disabled = __assign(__assign({}, tag), { background: '#F0F5FA !important', border: "1px solid ".concat('#A8B2BA'), color: '#8E9AA3' + ' !important', ':hover': {
        cursor: 'not-allowed !important',
    } });
export var pill = __assign(__assign({}, tag), { backgroundColor: '#d5e6f6', color: '#002E85' });
export var pillBorder = __assign(__assign({}, pill), { border: "2px solid ".concat('#002E85') });
var focus = {
    outline: '2px solid #1588af',
    outlineOffset: 2,
};
var resetFocus = {
    outline: 'none',
    outlineOffset: 0,
};
export var close = {
    backgroundColor: 'transparent',
    backgroundImage: getIcon(false),
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    border: 'none',
    borderRadius: 8,
    cursor: 'pointer',
    display: 'inline-block',
    height: 12,
    marginLeft: 4,
    position: 'relative',
    top: 0,
    width: 12,
    ':focus': focus,
    ':focus:not(:focus-visible)': resetFocus,
    ':focus-visible': focus,
    ':hover': {
        backgroundImage: getIcon(true),
        cursor: 'pointer',
    },
};
export var clickable = {
    label: 'turd',
    ':focus': focus,
    ':focus:not(:focus-visible)': resetFocus,
    ':focus-visible': focus,
    ':hover': {
        cursor: 'pointer',
    },
};
